export default "__VITE_ASSET__9e324fcb__"